var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocationDiningTableIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.1834 9.04183C18.3084 5.19183 14.9501 3.4585 12.0001 3.4585C12.0001 3.4585 12.0001 3.4585 11.9917 3.4585C9.05008 3.4585 5.68341 5.1835 4.80841 9.0335C3.83341 13.3335 6.46675 16.9752 8.85008 19.2668C9.73341 20.1168 10.8667 20.5418 12.0001 20.5418C13.1334 20.5418 14.2667 20.1168 15.1417 19.2668C17.5251 16.9752 20.1584 13.3418 19.1834 9.04183ZM12.0001 13.2168C10.5501 13.2168 9.37508 12.0418 9.37508 10.5918C9.37508 9.14183 10.5501 7.96683 12.0001 7.96683C13.4501 7.96683 14.6251 9.14183 14.6251 10.5918C14.6251 12.0418 13.4501 13.2168 12.0001 13.2168Z",
    fill: "#292D32"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationDiningTableIcon);
export default __webpack_public_path__ + "static/media/location-dining-table-icon.2f5421342a85130d48706aed4872d8ba.svg";
export { ForwardRef as ReactComponent };